export const exchangeRateEndpoints = (builder) => ({
    getExchangeRates: builder.query({
        query: (userGroup) => ({ url: `/exchange-rates?userGroup=${userGroup}`, method: 'get' }),
        transformResponse: (response) => {
            const rates = []
            for (const rate of response?.data) {
                if (rate.fromCurrency !== rate.toCurrency) {
                    rates.push(rate)
                }
            }
            response.data = rates
            return response
        },
        providesTags: ['Exchange Rates'],
    }),
    updateExchangeRate: builder.mutation({
        query: ({ id, ...exchangeRate }) => ({ url: `/exchange-rates/${id}`, method: 'patch', body: exchangeRate }),
        invalidatesTags: ['Exchange Rates'],
    }),
    createExchangeRate: builder.mutation({
        query: ({ exchangeRate }) => ({ url: `/exchange-rates`, method: 'post', body: exchangeRate }),
        invalidatesTags: ['Exchange Rates'],
    }),
    deleteExchangeRate: builder.mutation({
        query: ({ id, meta }) => ({ url: `/exchange-rates/${id}`, method: 'delete', body: { meta } }),
        invalidatesTags: ['Exchange Rates'],
    }),
})